export default __webpack_public_path__ + "static/media/projects.a80a4c93.svg";